'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import jQuery from 'jquery';

//we need to explicitly remove the pending xdr objects
//because in IE8, the xdr object is incorrectly subject to garbage
//collection after send() is invoked.
function _removeXDR(xdr) {
	for (var key in _pendingXDR) {
		if (_pendingXDR.hasOwnProperty(key)) {
			delete _pendingXDR[key];
			break;
		}
	}
}

var singleton = exports.singleton = Symbol.for('hs_instance');
var singletonEnforcer = Symbol.for('enforcing');
var _xdr = null;
var _pendingXDR = [];

var HTTPService = function () {
	function HTTPService(enforcer) {
		_classCallCheck(this, HTTPService);

		if (enforcer !== singletonEnforcer) {
			throw new Error('Cannot construct a singleton');
		}
	}

	_createClass(HTTPService, [{
		key: 'get',
		value: function get(hUrl, successCallback, errorCallback) {
			//check whether browser supports XDomainRequest.
			//usually just IE8/IE 9
			if (global.XDomainRequest) {
				try {
					_xdr = new XDomainRequest();
					if (_xdr) {
						_xdr.onload = function () {
							successCallback(_xdr.responseText);
							_removeXDR(_xdr);
						};
						_xdr.onerror = function () {
							_removeXDR(_xdr);
							if (errorCallback != null) errorCallback();
						};
						_xdr.ontimeout = function () {};
						_xdr.onprogress = function () {};

						_xdr.open('get', hUrl);

						setTimeout(function () {
							_xdr.send();
						}, 0);

						_pendingXDR.push(_xdr);
					}
				} catch (e) {
					_removeXDR(_xdr);
					if (errorCallback != null) errorCallback();
					console.log(e.message);
				}
			}
			//browser does not support XDomainRequest
			else {
					return fetch(hUrl, {
						method: "GET" // *GET, POST, PUT, DELETE, etc.
						//mode: "cors", // no-cors, cors, *same-origin
						//cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
						//credentials: "same-origin", // include, *same-origin, omit
						//headers: {
						//    "Content-Type": "application/json",
						// "Content-Type": "application/x-www-form-urlencoded",
						//},
						//redirect: "follow", // manual, *follow, error
						//referrer: "no-referrer", // no-referrer, *client
						//body: JSON.stringify(data), // body data type must match "Content-Type" header
					}).then(function (response) {
						return response.json();
					}); // parses response to JSON
				}
		}
	}, {
		key: 'post',
		value: function post(hUrl, data, successCallback, errorCallback) {
			//check whether the browser supports XDR.
			if (global.XDomainRequest) {
				try {
					_xdr = new XDomainRequest();
					if (_xdr) {
						_xdr.timeout = 3000;
						//_xdr.contentType = 'text/plain';
						_xdr.onload = function () {
							successCallback(_xdr.responseText);
							_removeXDR(_xdr);
						};
						_xdr.onerror = function () {
							_removeXDR(_xdr);
							if (errorCallback != null) errorCallback();
						};
						_xdr.ontimeout = function () {};
						_xdr.onprogress = function () {};
						_xdr.open('post', hUrl);
						_xdr.send(JSON.stringify(data));
					}
				} catch (e) {
					_removeXDR(_xdr);
					if (errorCallback != null) errorCallback();
					console.log(e.message);
				}
			} else {
				return fetch(hUrl, {
					method: "POST", // *GET, POST, PUT, DELETE, etc.
					//mode: "cors", // no-cors, cors, *same-origin
					//cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
					//credentials: "same-origin", // include, *same-origin, omit
					headers: {
						"Content-Type": "application/json"
						// "Content-Type": "application/x-www-form-urlencoded",
					},
					//redirect: "follow", // manual, *follow, error
					//referrer: "no-referrer", // no-referrer, *client
					body: JSON.stringify(data) // body data type must match "Content-Type" header
				}).then(function (response) {
					return response.json();
				}); // parses response to JSON
			}
		}
	}], [{
		key: 'hs_instance',
		get: function get() {
			if (!HTTPService[singleton]) {
				HTTPService[singleton] = new HTTPService(singletonEnforcer);
			}

			return HTTPService[singleton];
		}
	}]);

	return HTTPService;
}();

exports.default = HTTPService;